// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	/* List of AUI colors: https://design.atlassian.com/2.1/product/foundations/colors/ */
	--color-white: #fff;
	--color-medium-grey: #707070;
	--color-charcoal-grey: #333;
	--color-silver-grey: #e9e9e9;
	--color-grey: #e6e6e6;
	--color-blue: #3572b0;
	--color-blue-navy: #205081;
	--color-ash-gray: #ccc;
	--color-light-gray: #f5f5f5;
	--color-black: #000;
	--color-light-green: #93c37e;
	--color-transparent-dark-green: rgba(103, 171, 73, 0.15);
	--color-transparent-green: rgba(103, 171, 73, 0.5);
	--color-orange: #f79232;

	/* Height of wrapper of spinner. */
	--height-of-wrapper-spinner: 200px;

	/* transition */
	--transition-time: 0.2s;
	--transition-easing: ease;

	/* z-index of modal AUIDialog */
	--zIndexDialog: 2981;

	/* z-index of onboarding Blanket */
	--zindex-onboarding-blanket: 3100;
	/* z-index of onboarding Highlight Elements */
	--zindex-highlight-element: 4001;

	--dnd-highlight-border: var(--color-transparent-green);
	--dnd-highlight-bg: var(--color-transparent-dark-green);
	--dnd-drop-area: var(--color-light-green);

	--pagetree-selected-border: var(--color-ash-gray);
	--pagetree-selected-bg: var(--color-light-gray);

	--pagetree-hover-border: var(--color-ash-gray);
	--pagetree-hover-bg: var(--color-light-gray);

	--sidebar-border: var(--color-silver-grey);

	--adg3-blue: #2684ff;
}
`, "",{"version":3,"sources":["webpack://./src/helpers/variables.css"],"names":[],"mappings":"AAAA;CACC,qFAAqF;CACrF,mBAAmB;CACnB,4BAA4B;CAC5B,2BAA2B;CAC3B,4BAA4B;CAC5B,qBAAqB;CACrB,qBAAqB;CACrB,0BAA0B;CAC1B,sBAAsB;CACtB,2BAA2B;CAC3B,mBAAmB;CACnB,4BAA4B;CAC5B,wDAAwD;CACxD,kDAAkD;CAClD,uBAAuB;;CAEvB,kCAAkC;CAClC,kCAAkC;;CAElC,eAAe;CACf,uBAAuB;CACvB,yBAAyB;;CAEzB,+BAA+B;CAC/B,oBAAoB;;CAEpB,kCAAkC;CAClC,iCAAiC;CACjC,6CAA6C;CAC7C,gCAAgC;;CAEhC,sDAAsD;CACtD,uDAAuD;CACvD,yCAAyC;;CAEzC,iDAAiD;CACjD,+CAA+C;;CAE/C,8CAA8C;CAC9C,4CAA4C;;CAE5C,0CAA0C;;CAE1C,oBAAoB;AACrB","sourcesContent":[":root {\n\t/* List of AUI colors: https://design.atlassian.com/2.1/product/foundations/colors/ */\n\t--color-white: #fff;\n\t--color-medium-grey: #707070;\n\t--color-charcoal-grey: #333;\n\t--color-silver-grey: #e9e9e9;\n\t--color-grey: #e6e6e6;\n\t--color-blue: #3572b0;\n\t--color-blue-navy: #205081;\n\t--color-ash-gray: #ccc;\n\t--color-light-gray: #f5f5f5;\n\t--color-black: #000;\n\t--color-light-green: #93c37e;\n\t--color-transparent-dark-green: rgba(103, 171, 73, 0.15);\n\t--color-transparent-green: rgba(103, 171, 73, 0.5);\n\t--color-orange: #f79232;\n\n\t/* Height of wrapper of spinner. */\n\t--height-of-wrapper-spinner: 200px;\n\n\t/* transition */\n\t--transition-time: 0.2s;\n\t--transition-easing: ease;\n\n\t/* z-index of modal AUIDialog */\n\t--zIndexDialog: 2981;\n\n\t/* z-index of onboarding Blanket */\n\t--zindex-onboarding-blanket: 3100;\n\t/* z-index of onboarding Highlight Elements */\n\t--zindex-highlight-element: 4001;\n\n\t--dnd-highlight-border: var(--color-transparent-green);\n\t--dnd-highlight-bg: var(--color-transparent-dark-green);\n\t--dnd-drop-area: var(--color-light-green);\n\n\t--pagetree-selected-border: var(--color-ash-gray);\n\t--pagetree-selected-bg: var(--color-light-gray);\n\n\t--pagetree-hover-border: var(--color-ash-gray);\n\t--pagetree-hover-bg: var(--color-light-gray);\n\n\t--sidebar-border: var(--color-silver-grey);\n\n\t--adg3-blue: #2684ff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
